import { _$LH as m } from "./lit-html.js"; /**
                                           * @license
                                           * Copyright 2020 Google LLC
                                           * SPDX-License-Identifier: BSD-3-Clause
                                           */
var d = m.I,
  c = function c(e) {
    return e.strings === void 0;
  },
  a = function a() {
    return document.createComment("");
  },
  v = function v(e, i, t) {
    var _ = e._$AA.parentNode,
      r = i === void 0 ? e._$AB : i._$AA;
    if (t === void 0) {
      var A = _.insertBefore(a(), r),
        $ = _.insertBefore(a(), r);
      t = new d(A, $, e, e.options);
    } else {
      var _A = t._$AB.nextSibling,
        _$ = t._$AM,
        o = _$ !== e;
      if (o) {
        var _t$_$AQ, _t;
        var s;
        (_t$_$AQ = (_t = t)._$AQ) !== null && _t$_$AQ !== void 0 && _t$_$AQ.call(_t, e), t._$AM = e, t._$AP !== void 0 && (s = e._$AU) !== _$._$AU && t._$AP(s);
      }
      if (_A !== r || o) {
        var _s = t._$AA;
        for (; _s !== _A;) {
          var n = _s.nextSibling;
          _.insertBefore(_s, r), _s = n;
        }
      }
    }
    return t;
  },
  p = function p(e, i) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e;
    return e._$AI(i, t), e;
  },
  l = {},
  u = function u(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : l;
    return e._$AH = i;
  },
  g = function g(e) {
    return e._$AH;
  },
  B = function B(e) {
    e._$AR(), e._$AA.remove();
  };
export { g as getCommittedValue, v as insertPart, c as isSingleExpression, B as removePart, p as setChildPartValue, u as setCommittedValue };